import { render, staticRenderFns } from "./WordFrequencyapi.vue?vue&type=template&id=477a9269&scoped=true&"
import script from "./WordFrequencyapi.vue?vue&type=script&lang=js&"
export * from "./WordFrequencyapi.vue?vue&type=script&lang=js&"
import style0 from "./WordFrequencyapi.vue?vue&type=style&index=0&lang=less&"
import style1 from "./WordFrequencyapi.vue?vue&type=style&index=1&id=477a9269&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477a9269",
  null
  
)

export default component.exports